import React from 'react'
// import { StaticQuery, graphql, Link } from 'gatsby'
import { Link } from 'gatsby'
import styled from 'styled-components'
// import Img from 'gatsby-image'


class GridBlock extends React.Component {
    render() {
      // const attractions = [
      //   { name: "Night Life", img: "", title: "Top 12 Night Clubs in Moscow", slug: "/"},
      //   { name: "Strip Clubs", img: "", title: "Moscow Strip Clubs: The Naked Truth", slug: "/"},
      //   { name: "Erotic Massage", img: "", title: "Erotic Massage Salons: Everything You Should Know", slug: "/"},
      // ]
      return(
          <Container>
            <Wrap>
              <Item>
                <Link to={'/moscow-erotic-massage/'}>
                  <picture><img src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559149701/Landing-MAIN/massage.jpg" alt="moscow"/></picture>
                </Link>
                <Header>
                  <Link to={'/moscow-erotic-massage/'}><span>Everything You Need to Know About Erotic Massage in Moscow</span></Link>
                </Header>
              </Item>

              <Item>
                <Link to={'/moscow-nightclubs/'}>
                  <picture><img src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559149701/Landing-MAIN/nightlife.jpg" alt="moscow russia"/></picture>
                </Link>
                <Header>
                  <Link to={'/moscow-nightclubs/'}><span>Moscow Nightlife: Explore The Hottest Night Clubs in The City</span></Link>
                </Header>                           
              </Item>

              <Item>
                <Link to={'/moscow-strip-clubs/'}>
                  <picture><img src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559149701/Landing-MAIN/strip.jpg" alt="moskva"/></picture>
                </Link>
                <Header>
                  <Link to={'/moscow-strip-clubs/'}><span>Moscow Strip Clubs: Your Guide to Adult Entertainment</span></Link>
                </Header>                         
              </Item>

            </Wrap>
          </Container>
      )
    }
}

const Item = styled.div`
  max-width: 300px;
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);
  box-sizing: border-box;
  @media (max-width: 600px) {
        max-width: 600px;
        margin-bottom: 1.5rem;
        /* span {
          padding: 0 10px 0;
          font-size: 1.8rem;
        } */
    }
`;
const Wrap = styled.div`
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(300px, 1fr) );
  @media (max-width: 600px) {
    display: block;
    }
`;

const Container = styled.div`
  margin: 1.5rem 0;
    a {
        display: block;
        cursor: pointer;
        border-bottom: none;
        picture {
            display: block;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            width: 100%;
            height: inherit;
            overflow: hidden;
            img {
                display: inherit;
                width: 100%;
                object-fit: cover;
                @media (max-width: 600px) {
                  max-height: 150px;
                }
            }
        }
    }
`

const Header = styled.div`
    border-left: 4px solid #FF0000;
    background: #fff;
    line-height: 30px;
    padding: 10px 5px;
    a {
      border-bottom: none;
    }
    span {
        display: inline-block;
        background: #fff;
        padding: 0px 10px;
        color: #000;
        font-family: 'Roboto', sans-serif;
        font-size: 1.8rem;
        font-weight: 700;
        font-style: italic;
    }
    @media (max-width: 700px) {
        line-height: 25px;
        /* span {
          padding: 0 10px 0;
          font-size: 1.8rem;
        } */
    }
`;

export default GridBlock

